import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable, QueryList, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Modal } from 'interfaces';
import { BrowserService } from 'utils';

@Injectable({
  providedIn: 'root',
})
export class ModalsService {
  private dialog = inject(MatDialog);
  private browser = inject(BrowserService);
  private pageExitModalId: string | undefined;
  private _modals: { [modalId: string]: TemplateRef<unknown> } = {};

  public registerModals(modalsData: Modal[], modalsList: QueryList<TemplateRef<unknown>>) {
    modalsData.forEach((modal, index) => {
      this._modals[modal.id] = modalsList.get(index);

      if (modal.showOnPageExit) {
        this.executeFnForDevice(() => {
          this.pageExitModalId = modal.id;
        }, modal.showOnDevices);
      }
    });
  }

  public unregisterModals() {
    this._modals = {};
    this.pageExitModalId = undefined;
  }

  public openConfirmationDialogIfAny() {
    if (this.pageExitModalId) {
      return this.openModal(this.pageExitModalId)
        .afterClosed()
        .pipe(map(() => true));
    }

    return of(true);
  }

  public openModal(id: string) {
    const modal = this._modals && this._modals[id];

    if (modal) {
      return this.dialog.open(this._modals[id]);
    }
    return null;
  }

  public executeFnForDevice(fn: () => void, device: 'ALL' | 'MOBILE' | 'DESKTOP') {
    if (
      device === 'ALL' ||
      (device === 'MOBILE' && this.browser.matchMedia('(max-width: 1023px)')) ||
      (device === 'DESKTOP' && this.browser.matchMedia('(min-width: 1024px)'))
    ) {
      fn();
    }
  }

  public openDialog<TData>(
    component: ComponentType<unknown>,
    options: MatDialogConfig<TData> = {}
  ): MatDialogRef<unknown> {
    const dialogConfig: MatDialogConfig<TData> = {
      ...options,
      backdropClass: ['bg-[--basic-white-75]'],
    };

    return this.dialog.open(component, dialogConfig);
  }
}
